// CookieBanner.js - Simple cookie banner for Mantine v8
// Place in /mnt/project/Components/CookieBanner.js

import { useState, useEffect } from 'react';
import { Box, Container, Group, Text, Button, Anchor } from '@mantine/core';
import { Link } from 'react-router-dom';
import { IconCookie } from '@tabler/icons-react';

export function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // Check if user has already made a choice
    const consent = localStorage.getItem('cookie-consent');
    if (!consent) {
      setVisible(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookie-consent', 'accepted');
    setVisible(false);
  };

  const handleReject = () => {
    localStorage.setItem('cookie-consent', 'rejected');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <Box
      style={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        backgroundColor: '#1a1b1e',
        borderTop: '1px solid #373A40',
        padding: '1rem 0',
        zIndex: 1000,
        boxShadow: '0 -2px 10px rgba(0, 0, 0, 0.3)',
      }}
    >
      <Container size="xl">
        <Group justify="space-between" align="center" wrap="wrap" gap="md">
          {/* Left - Message */}
          <Group gap="sm" style={{ flex: 1, minWidth: 300 }}>
            <IconCookie size={24} color="#4dabf7" />
            <Text size="sm" c="white">
              Mēs izmantojam sīkdatnes, lai uzlabotu jūsu pieredzi. 
              {' '}
              <Anchor
                component={Link}
                to="/legal/privacy"
                size="sm"
                c="#4dabf7"
                style={{ textDecoration: 'underline' }}
              >
                Uzzināt vairāk
              </Anchor>
            </Text>
          </Group>

          {/* Right - Buttons */}
          <Group gap="sm">
            <Button
              variant="subtle"
              color="gray"
              size="sm"
              onClick={handleReject}
            >
              Noraidīt
            </Button>
            <Button
              variant="filled"
              color="blue"
              size="sm"
              onClick={handleAccept}
            >
              Pieņemt
            </Button>
          </Group>
        </Group>
      </Container>
    </Box>
  );
}